import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getServiceQueryOptions, getServicesQueryOptions } from "./get.hooks";

export function useDeleteService(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/services/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getServicesQueryOptions.queryKey, (old) =>
        old?.filter((s) => s.id.toString() !== id),
      );
      queryClient.resetQueries({
        queryKey: getServiceQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.serviceDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteServiceError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
